import { Fragment, ReactElement } from 'react';
import ResearchFamilyNotificationsDetailCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-family/detail';

const ResearchFamilyNotificationsDetailCivilStatusFatherPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchFamilyNotificationsDetailCivilStatusShared isFather />
    </Fragment>
  );
};

ResearchFamilyNotificationsDetailCivilStatusFatherPage.displayName =
  'Research Family Notifications CivilStatusFatherPage component';

export default ResearchFamilyNotificationsDetailCivilStatusFatherPage;
